<div class="bg-grey-light-l">
  <app-admin-panel-menu></app-admin-panel-menu>
</div>
<router-outlet></router-outlet>
